import FacebookLogin from '@greatsumini/react-facebook-login';
import { Button } from '@madpaws/design-system';
import getConfig from 'next/config';
import React from 'react';

import { trackEvent } from '~/components/analytics/analytics';
import { USER_CONTINUE_LOGIN_CLICK_EVENT_NAME } from '~/components/analytics/constants';

import { AuthMethods, FACEBOOK_LOGIN_GRANT_TYPE } from '../constants';

import type { SuccessResponse } from '@greatsumini/react-facebook-login';
import type { ReactElement } from 'react';

const { publicRuntimeConfig } = getConfig();

type Props = {
  onLoginSuccess: (token: string, authMethod: AuthMethods) => void;
};

export const FacebookLoginButton = ({ onLoginSuccess }: Props): ReactElement => {
  const renderButton = ({ onClick }: { onClick?: () => void }): ReactElement => {
    const handleOnClick = (): void => {
      trackEvent(USER_CONTINUE_LOGIN_CLICK_EVENT_NAME, { grant_type: FACEBOOK_LOGIN_GRANT_TYPE });
      onClick?.();
    };

    return (
      <Button
        iconLeading={
          <img
            alt="google icon"
            src={`${publicRuntimeConfig.staticPath}/icons/sign-in/fbIconCircle.svg`}
          />
        }
        isFullBleed
        label="Continue with Facebook"
        onClick={handleOnClick}
        variant="secondary"
      />
    );
  };

  const handleLoginSuccess = (response: SuccessResponse): void => {
    onLoginSuccess(response.accessToken, AuthMethods.FACEBOOK);
  };

  return (
    <FacebookLogin
      appId={process.env.NEXT_PUBLIC_FACEBOOK_APP_ID || ''}
      onFail={(error): void => console.log(error.status)}
      onSuccess={handleLoginSuccess}
      render={renderButton}
    />
  );
};
